import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export type AxiosErrorLike<
  ResponseShape = { data?: unknown; headers?: Record<string, unknown> },
> = {
  isAxiosError: boolean;
  response?: ResponseShape;
};

export function isAxiosErrorLike<
  ResponseShape = { data?: unknown; headers?: Record<string, unknown> },
>(error: unknown): error is AxiosErrorLike<ResponseShape> {
  return Boolean(error && typeof error === "object" && "isAxiosError" in error);
}

// 添加缓存相关的工具函数
export async function getCacheWithRetry(
  key: string,
  maxRetries = 3,
): Promise<string | null> {
  let retries = 0;

  while (retries < maxRetries) {
    try {
      // 这里实现获取缓存的逻辑
      // 例如从 Redis 或其他缓存服务获取数据
      // 这里只是一个示例实现
      const cachedData = localStorage.getItem(key);
      return cachedData;
    } catch (error) {
      retries++;
      if (retries >= maxRetries) {
        console.error(`获取缓存失败，已重试 ${retries} 次:`, error);
        return null;
      }
      // 指数退避策略
      await new Promise((resolve) =>
        setTimeout(resolve, 100 * Math.pow(2, retries)),
      );
    }
  }

  return null;
}

export async function setCacheWithRetry(
  key: string,
  value: string,
  maxRetries = 3,
): Promise<boolean> {
  let retries = 0;

  while (retries < maxRetries) {
    try {
      // 这里实现设置缓存的逻辑
      // 例如存储到 Redis 或其他缓存服务
      // 这里只是一个示例实现
      localStorage.setItem(key, value);
      return true;
    } catch (error) {
      retries++;
      if (retries >= maxRetries) {
        console.error(`设置缓存失败，已重试 ${retries} 次:`, error);
        return false;
      }
      // 指数退避策略
      await new Promise((resolve) =>
        setTimeout(resolve, 100 * Math.pow(2, retries)),
      );
    }
  }

  return false;
}
